<template>
  <div class="model-validator">
    <div class="header-area">
      <div class="dropdown1">
        <select v-model="model1">
          <option value="">None</option>
          <option v-for="model in model_names" :key="model" :value="model">{{model}}</option>
        </select>
      </div>
      <div class="dropdown2">
        <select v-model="model2">
          <option value="">None</option>
          <option v-for="model in model_names" :key="model" :value="model">{{model}}</option>
        </select>
      </div>
      <div class="dropdown3">
        <select v-model="model3">
          <option value="">None</option>
          <option v-for="model in model_names" :key="model" :value="model">{{model}}</option>
        </select>
        <input type="button" v-on:click="loadResults" value="Go!" />
      </div>
    </div>
    <!-- end header, start results -->
    <div v-if="loading">Loading...</div>
    <div class="results-area">
      <div class="results-row" v-for="(result,row_number) in model_results" :key="result.runtime_face_uuid">
        <div class="runtime-info-area">
          <div class="runtime-image-area">
              <img :src="'http://node-runner.p.owal.io:9612/faceimage/' + result.runtime_face_uuid" height='160dp'/>  
             <!-- <img src="../assets/fake_runtime_face.jpg" height='160dp'/>  -->
          </div>
          <p>
            {{result.camera_description}}
          </p>
          <p>
            {{result.captured_at}}
          </p>
        </div>
         <!-- <div class="result-predictions-area">  -->
          <div class="result-prediction" v-for="prediction in result.predictions" :key="result.runtime_face_uuid + prediction.model_name">
            <div v-if="prediction.frontend_face_uuid && (prediction.match_confidence > 0.9)" class="image-area">
                <img :src="imageUriForFrontendFaceUUID(prediction.frontend_face_uuid)" />  
               <!-- <img src='../assets/fake_frontend_face.jpg' />  -->
            </div>
            <div v-else>
              <div v-if="!prediction.frontend_face_uuid">
                Not a face
              </div>
              <div v-else>
                &nbsp;
              </div>
            </div>
            <div class="name-area">
              <div id="circle" v-bind:style="{background: colorForMatchConfidence(prediction.match_confidence)}" />&nbsp;{{confidenceformat(prediction.match_confidence)}}&nbsp;
              <router-link v-bind:to="'/faces/' + personNameForUUID(prediction.frontend_face_uuid)" class="potential-match-name">{{personNameForUUID(prediction.frontend_face_uuid)}}</router-link>
            </div>
          </div>
         <!-- </div>  -->
      </div>
    </div>
  </div>
</template>

<script>

import InfiniteLoading from 'vue-infinite-loading';

import {BASE_URL} from '../api/base';
import {mapGetters} from 'vuex';
import {facestrainingresults, facestrainingmodels} from '../api/faces';
import moment from 'moment';
import momenttz from 'moment-timezone';
import {confidenceformat, colorForMatchConfidence} from '../util/confidence';

export default {
  name: 'model-validator',
  data: function() {
    return {
      model_names: [],
      model1: '',
      model2: '',
      model3: '',
      model_results: [],
      BASE_URL,
      fake: true,
      loading: false,
    }
  },
  computed: mapGetters(['frontendFaces', 'isLoggedIn']),
  created() {
    this.updateModelList();
    // this.loadResults();
  },
  methods: {
    confidenceformat, colorForMatchConfidence,
    getTimeDiff(time_str) {
      console.log(time_str);
      return moment.utc(time_str).fromNow();
    },
    getTimeString(time_str) {
      return moment.utc(time_str).tz('America/New_York').format("dddd, MMMM Do YYYY, h:mm:ss a");
    },
    imageUriForFrontendFaceUUID(frontend_face_uuid) {
      if (!frontend_face_uuid) return '';
      const face = this.frontendFaces.find(x => x.frontend_face_uuid == frontend_face_uuid);
      if (!face) {
        console.log(`frontend face not found: ${frontend_face_uuid}`);
        return '';
      }
      if (!face.images || !face.images.length) {
        console.log(`frontend face has no images: ${frontend_face_uuid}`);
        return '';
      }
      return face.images[0].thumbnail_uri;
    },
    updateModelList() {
      facestrainingmodels().then(res => res.data).then(data => {
        if (!data.ok) {
          console.error(data.err);
          return;
        }
        this.model_names = data.models.map(x => x.name);
      })
    },
    loadResults() {
      this.loading = true;
      facestrainingresults([this.model1, this.model2, this.model3]).then(res => res.data).then(data => {
        this.loading = false;
        if (!data.ok) {
          console.error(data.err);
          return;
        }
        this.model_results = data.results;
      })
    },
    personNameForUUID(frontend_face_uuid) {
      if (!frontend_face_uuid) return '';
      const face = this.frontendFaces.find(x => x.frontend_face_uuid == frontend_face_uuid);
      if (!face) {
        console.log(`frontend face not found: ${frontend_face_uuid}`);
        return '';
      }
      return face.person_name;
    },

  },
  components: {
    InfiniteLoading,
  },
}
</script>

<style scoped>
.header-area {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  grid-auto-rows: minmax(100px, auto);;
  /* flex-direction: row; */
}

.dropdown1 {
  grid-column: 2;
}

.results-area { 
   /* display: grid;
  grid-template-columns: 100px 1fr 1fr 1fr 1fr;
   grid-gap: 10px;
  grid-template-rows: repeat(aut-fill, 120px);    */
    display: flex;
   flex-direction: column; 
}

.results-row {
   display: flex;
  flex-direction: row; 
}

.runtime-info-area {
   /* grid-column: 1;  */
     display: flex; 
  flex-direction: column;
  flex: 1;
    /* grid-row-start: auto; */

  /* background-color:yellow; */
}

.result-predictions-area {
    display: flex;
  flex-direction: row; 
    /* background-color: yellowgreen;  */
  /* grid-column: 2;  */
}

.result-prediction {
    display: flex;
  flex-direction: column;
  margin-right: 10px;
  margin-left: 10px;
  flex: 1;
}

.name-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

#circle {
  width: 10px;
  height: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  background: red;
  margin-right: 5px;
  margin-top: 5px;
}

</style>



// WEBPACK FOOTER //
// ModelValidator.vue?0a3ba71c